import { createAction } from 'redux-actions';
import { ControllerState } from '../../worker/controller-handlers';

export const UPDATE_CONTROLLER_STATE = 'UPDATE_CONTROLLER_STATE';

export const updateControllerState = createAction<ControllerState>(
  UPDATE_CONTROLLER_STATE,
);
